import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.sass']
})
export class ErrorComponent implements OnInit {
  errorMsg: any;

  constructor(private translationService: TranslocoService) { }

  ngOnInit(): void {

    this.errorMsg = this.translationService.translate(window.errorObj);
  }
}
